import React, { useState, useEffect } from 'react';
import { navigate } from 'gatsby';
import { Form, Progress, Row, Col } from 'antd';
import Cookies from 'js-cookie';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import TextField from 'components/Form/TextField';
import RadioGroup from 'components/Form/RadioGroup';
import Select from 'components/Form/Select';
import Button from 'components/Button';
import './DemoForm.less';
import 'antd/lib/progress/style/index.css';
import Tooltip from 'components/Tooltip';
import { saveForm, init } from 'services/marketoService';
import {
  industryList,
  technicianOptionsDemo4,
  staffCountOptions,
  focusOptions,
  typeOfWorkOptions,
  otherIndustryList,
} from 'components/Form/utils/generalFormData';
import { getSetCookies } from 'utils/cookieUtility';
import { mapFormFieldValues } from 'utils/marketo';
import { FormRedirect } from './FormRedirect';
import { useChiliPiperLoad, isValidChiliPiperSubmission } from './chilipiperHelpers';
import { StepContainer, SignupFormContainer, FormTitle } from './styles';

const DemoForm = ({
  dataPosition,
  width,
  height,
  backgroundColor,
  titleColor,
  title,
  buttonLabel,
  footer,
  formType,
  shadow,
  marketoFormId,
  redirectUrl,
  initEmailValue,
  customDQ,
  ...otherProps
}) => {
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const secondBackgroundColor = 'white';
  const secondTitleColor = 'black';
  let slider;

  const dropdownOtherIndustry = otherIndustryList.slice(1);
  const dropdownIndustry = industryList.slice(1);
  const chiliPiperLoaded = useChiliPiperLoad();

  const [formStep, setFormStep] = useState(0);
  const [isOtherIndustryShow, setOtherIndustryShow] = useState(false);

  const [values, setValues] = useState({
    email: Cookies.get('email') || initEmailValue || '',
    firstName: Cookies.get('firstName') || '',
    lastName: Cookies.get('lastName') || '',
    company: Cookies.get('company') || '',
    mobilePhone: Cookies.get('mobilePhone') || '',
    utm_source: null,
    utm_medium: null,
    utm_campaign: null,
    utm_content: null,
    utm_term: null,
    utm_promo: null,
    microsoftClickID: Cookies.get('msclkid') || '',
    fbclid: Cookies.get('fbclid') || '',
    order_id: Cookies.get('order_id') || '',
    clickId: Cookies.get('clickId') || '',
    gclid: '',
    creative: '',
    keyword: '',
    matchtype: '',
  });

  const sliderSettings = {
    dots: false,
    arrows: false,
    infinite: true,
    draggable: false,
    touchMove: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
    accessibility: false,
    cssEase: 'cubic-bezier(0.55, 0.085, 0.68, 0.53)',
  };

  const nameType = {
    email: { name: 'Email', step: 0 },
    firstName: { name: 'First Name', step: 0 },
    lastName: { name: 'Last Name', step: 0 },
    mobilePhone: { name: 'Phone Number', step: 0 },
    company: { name: 'Company', step: 0 },
    techniciansNumber: { name: 'Technicians', step: 2 },
    officeStaffNumber: { name: 'Office Staff', step: 3 },
    areaOfFocus: { name: 'Area Of Focus', step: 4 },
    typeOfBusiness: { name: 'Type Of Business', step: 4 },
    industry: { name: 'Industry', step: 1 },
    otherIndustry: { name: 'Other Industry', step: 1 },
  };

  const [formValid, setFormValid] = useState({
    email: 0,
    firstName: 0,
    lastName: 0,
    mobilePhone: 0,
    company: 0,
    techniciansNumber: 0,
    officeStaffNumber: 0,
    areaOfFocus: 0,
    typeOfBusiness: 0,
    industry: 0,
  });

  const [formErrors, setFormErrors] = useState({
    email: '',
    firstName: '',
    lastName: '',
    mobilePhone: '',
    company: '',
    techniciansNumber: '',
    officeStaffNumber: '',
    areaOfFocus: '',
    typeOfBusiness: '',
    industry: '',
    otherIndustry: '',
  });

  const resetValidation = ids => {
    const tmpFormValid = { ...formValid };
    const tmpFormErrors = { ...formErrors };

    ids.forEach(id => {
      tmpFormValid[id] = 0;
      tmpFormErrors[id] = '';
    });

    setFormValid(tmpFormValid);
    setFormErrors(tmpFormErrors);
  };

  const checkFieldValidate = (id, value) => {
    const fieldValidation = formValid;
    const fieldValidationErrors = formErrors;

    if (fieldValidation[id] !== undefined) {
      fieldValidation[id] = value && value.length ? 1 : -1;
      fieldValidationErrors[id] =
        fieldValidation[id] === 1 ? '' : `${nameType[id].name} is required`;

      switch (id) {
        case 'mobilePhone':
          fieldValidation[id] = value && value.length === 14 ? 1 : -1;
          fieldValidationErrors[id] =
            fieldValidation[id] === 1 ? fieldValidation[id] : `${nameType[id].name} is invalid`;
          break;
        case 'email':
          fieldValidation[id] =
            value && value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i) ? 1 : -1;
          fieldValidationErrors[id] =
            fieldValidation[id] === 1 ? fieldValidation[id] : `${nameType[id].name} is invalid`;
          break;
        default:
          break;
      }
    }

    setFormValid(fieldValidation);
    setFormErrors(fieldValidationErrors);

    return fieldValidation[id];
  };

  const saveMarketoData = async (data, step, isResubmit) => {
    try {
      await saveForm({
        ...data,
        step,
        marketoFormId,
        ...(data.typeOfBusiness || data.areaOfFocus
          ? {
              businessFocus: `${data.areaOfFocus || ''}${
                data.typeOfBusiness ? ` ${data.typeOfBusiness}` : ''
              }`,
            }
          : {}),
        ...(data.officeStaffNumber
          ? {
              partTimeOffice: data.officeStaffNumber === '.5',
              officeStaffNumber: parseInt(parseFloat(data.officeStaffNumber)).toString(),
            }
          : {}),
      });
    } catch (e) {
      !isResubmit && saveMarketoData(data, step, true);
      console.log(e);
    }
  };

  const setValue = (ids, value) => {
    const tmpValues = { ...values };

    ids.forEach(id => {
      tmpValues[id] = value;
      checkFieldValidate(id, tmpValues[id]);
    });

    setValues(tmpValues);
  };

  const prevStep = () => {
    const newStep = formStep - 1;

    const clearOut = Object.keys(nameType).filter(x => nameType[x].step >= newStep && newStep > 0);

    setValue(clearOut, '');
    resetValidation(clearOut);

    setFormStep(newStep);
    setOtherIndustryShow(false);

    if (newStep === 0) {
      slider.slickGoTo(newStep, true);
    } else {
      slider.slickPrev();
    }
  };

  const nextStep = async () => {
    const newStep = formStep + 1;
    setFormStep(newStep);

    if (formStep === 0) {
      slider.slickGoTo(newStep, true);
    } else {
      slider.slickNext();
    }
    await saveMarketoData(values, 1);
  };

  const isValid = (fields = []) => {
    return !fields.some(x => formValid[x] < 1);
  };

  const onFocus = (id, value) => {
    setValue([id], value);
  };

  const onChange = (id, value) => {
    onFocus(id, value);
    nextStep();
  };

  const onHandleBlur = (id, newValue) => {
    checkFieldValidate(id, newValue);
  };

  const stepOneClick = async () => {
    Object.keys(nameType)
      .filter(key => nameType[key].step === 0)
      .forEach(key => {
        Cookies.set(key, values[key]);
      });

    setIsButtonDisabled(true);
  };

  const stepOneAction = async () => {
    const stepFields = Object.keys(nameType).filter(x => nameType[x].step === 0);

    stepFields.forEach(id => {
      setValue([id], values[id]);
    });

    if (isValid(stepFields)) {
      Bizible &&
        Bizible.Push('User', {
          eMail: values.email, // required
        });

      nextStep();
    } else {
      setIsButtonDisabled(false);
    }
  };

  const industryClick = (id, value) => {
    if (value === 'Other') {
      setOtherIndustryShow(true);
      setFormValid({ ...formValid, otherIndustry: 0 });
    } else {
      setOtherIndustryShow(false);
      nextStep();
    }
    onFocus(id, value);
  };

  const onSubmit = async () => {
    const stepFields = Object.keys(nameType).filter(x => nameType[x].step === 4);
    stepFields.forEach(id => {
      setValue([id], values[id]);
    });

    if (isValid(stepFields)) {
      Bizible &&
        Bizible.Push('User', {
          eMail: values.email, // required
        });
      const updateValue = { ...values };
      setValues(updateValue);

      dataLayer.push({
        event: 'form submitted',
        'data-position': dataPosition,
        form_type: formType || 'Demo 4 Form - Completed',
        techcount: values.techniciansNumber || '',
        officecount: values.officeStaffNumber || '',
        revenue: values.techniciansNumber * 250 || '',
        ...values,
      });
      const isValidCp = isValidChiliPiperSubmission(updateValue);

      await saveMarketoData(updateValue, 2);

      const formRedirectData = {
        techs: updateValue.techniciansNumber,
        officeStaff: updateValue.officeStaffNumber,
        areaOfFocus: updateValue.areaOfFocus,
        industry: updateValue.industry,
        otherIndustry: updateValue.otherIndustry,
        typeOfBusiness: updateValue.typeOfBusiness,
        email: updateValue.email,
      };

      if (isValidCp && chiliPiperLoaded) {
        const newLead = {
          FirstName: updateValue?.firstName,
          LastName: updateValue?.lastName,
          Email: updateValue?.email,
          Estimated_Total_Potential_Office_Users__c: parseInt(
            updateValue?.officeStaffNumber + 5
          ).toString(),
          industry: updateValue?.industry,
        };
        window.ChiliPiper.submit('servicetitan', 'website-booking', {
          title: 'Thanks! What time works best for a quick call?',
          titleStyle: 'Roboto 22px #EA5938',
          lead: newLead,
          map: true,
          onClose: () => {
            redirectUrl
              ? navigate(`${redirectUrl}/`)
              : FormRedirect('normal', { ...formRedirectData, showChiliPiper: true });
          },
          debug: true,
          onError: err => {
            console.log('cp error: ', err);
            redirectUrl
              ? navigate(`${redirectUrl}/`)
              : FormRedirect('normal', {
                  ...formRedirectData,
                  showChiliPiper: false, // if error with CP, don't halt demo flow
                });
          },
        });
      } else {
        redirectUrl
          ? navigate(`${redirectUrl}/`)
          : FormRedirect('normal', { ...formRedirectData, showChiliPiper: false, customDQ });
      }
    } else {
      FormRedirect('normal', {
        techs: values.techniciansNumber,
        officeStaff: values.officeStaffNumber,
        areaOfFocus: values.areaOfFocus,
        industry: values.industry,
        otherIndustry: values.otherIndustry,
        typeOfBusiness: values.typeOfBusiness,
        email: values.email,
        showChiliPiper: false,
      });
    }
  };

  const afterChangeHandler = currentSlide => {
    setFormStep(currentSlide);
  };

  const getFormPercent = () => {
    return (
      formStep * 20 +
      (formValid.typeOfBusiness === 1 ? 10 : 0) +
      (formValid.areaOfFocus === 1 ? 10 : 0)
    );
  };

  useEffect(() => {
    if (formStep > 0) {
      dataLayer.push({
        event: 'form submitted',
        form_type: 'Demo 4 Form',
        form_step: formStep,
        ...mapFormFieldValues(values),
      });
    }
  }, [formStep]);

  useEffect(() => {
    if (isButtonDisabled && formStep === 0) {
      stepOneAction();
    } else if (formStep === 1) {
      setIsButtonDisabled(false);
    }
  }, [isButtonDisabled, formStep]);

  useEffect(() => {
    init(marketoFormId);
    const tempValues = getSetCookies(values);
    setValues(tempValues);
  }, []);

  return (
    <SignupFormContainer
      className={`demo-form--main-container ${
        otherProps.demoForm5Style ? 'demo-form-style--5' : ''
      }`}
      width={width}
      height={height}
      backgroundColor={formStep === 0 ? backgroundColor : secondBackgroundColor}
      titleColor={titleColor}
      shadow={shadow}
      style={otherProps.style}
    >
      <Form className="signup-form--form" data-position="Body - Demo Form">
        <Slider ref={c => (slider = c)} {...sliderSettings} afterChange={afterChangeHandler}>
          <div className="data-layer-form signup-form--step1">
            <FormTitle
              className="signup-form--title"
              titleColor={formStep === 0 ? titleColor : secondTitleColor}
            >
              {title}
            </FormTitle>
            <Form.Item>
              <TextField
                id="email"
                type="text"
                nameType={nameType.email.name}
                placeholderText={nameType.email.name}
                values={values}
                formValid={formValid}
                formErrors={formErrors}
                handleBlur={onHandleBlur}
                handleChange={onFocus}
              />
            </Form.Item>
            <Form.Item>
              <TextField
                id="firstName"
                type="text"
                nameType={nameType.firstName.name}
                placeholderText={nameType.firstName.name}
                values={values}
                formValid={formValid}
                formErrors={formErrors}
                handleBlur={onHandleBlur}
                handleChange={onFocus}
              />
            </Form.Item>
            <Form.Item>
              <TextField
                id="lastName"
                type="text"
                nameType={nameType.lastName.name}
                placeholderText={nameType.lastName.name}
                values={values}
                formValid={formValid}
                formErrors={formErrors}
                handleBlur={onHandleBlur}
                handleChange={onFocus}
              />
            </Form.Item>
            <Form.Item>
              <TextField
                id="mobilePhone"
                type="number"
                format="(###) ###-####"
                nameType={nameType.mobilePhone.name}
                placeholderText={nameType.mobilePhone.name}
                values={values}
                formValid={formValid}
                formErrors={formErrors}
                handleBlur={onHandleBlur}
                handleChange={onFocus}
              />
            </Form.Item>
            <Form.Item>
              <TextField
                id="company"
                type="text"
                nameType={nameType.company.name}
                placeholderText={nameType.company.name}
                values={values}
                formValid={formValid}
                formErrors={formErrors}
                handleBlur={onHandleBlur}
                handleChange={onFocus}
              />
            </Form.Item>
            <Form.Item>
              <Button
                className="signup-form--submit-button"
                type="primary"
                width="100%"
                shadow={false}
                onClick={stepOneClick}
                disabled={isButtonDisabled}
              >
                {buttonLabel}
              </Button>
            </Form.Item>
          </div>
          <div className="data-layer-form signup-form--step2">
            <StepContainer>
              <Row>
                <Col flex sm={2} xs={3} lg={4}>
                  <button
                    data-position="Form - CTA"
                    type="button"
                    onClick={prevStep}
                    className="slick-prev"
                  >
                    Previous
                  </button>
                </Col>
                <Col flex sm={20} xs={19} lg={18}>
                  <FormTitle className="signup-form--title" titleColor={secondTitleColor}>
                    What is your company's main industry?
                  </FormTitle>
                </Col>
              </Row>
              <Form.Item>
                <RadioGroup
                  id="industry"
                  options={dropdownIndustry}
                  formValid
                  values={values}
                  handleFocus={industryClick}
                />
                <Form.Item className={isOtherIndustryShow ? '' : 'hide-form-item'}>
                  <Select
                    id="otherIndustry"
                    nameType={nameType.otherIndustry.name}
                    formValid
                    placeholder="Select other industry..."
                    options={dropdownOtherIndustry}
                    handleChange={onChange}
                    values={values}
                  />
                </Form.Item>
              </Form.Item>
            </StepContainer>
          </div>
          <div className="data-layer-form signup-form--step3">
            <StepContainer>
              <Row>
                <Col sm={2} xs={3}>
                  <button
                    data-position="Form - CTA"
                    type="button"
                    onClick={prevStep}
                    className="slick-prev"
                  >
                    Previous
                  </button>
                </Col>
                <Col sm={21} xs={19}>
                  <FormTitle className="signup-form--title" titleColor={secondTitleColor}>
                    How many technicians work at your company?
                    <Tooltip className="signup-form--description-tooltip">
                      How many full-time technicians (e.g. plumbers, or electricians) work at your
                      company? For best results, omit apprentices and helpers.
                    </Tooltip>
                    <span className="signup-form--description-normal">
                      How many full-time technicians (e.g. plumbers, or electricians) work at your
                      company? For best results, omit apprentices and helpers.
                    </span>
                  </FormTitle>
                </Col>
              </Row>
              <Form.Item>
                <RadioGroup
                  id="techniciansNumber"
                  options={technicianOptionsDemo4}
                  formValid
                  handleFocus={onChange}
                  values={values}
                />
              </Form.Item>
            </StepContainer>
          </div>
          <div className="data-layer-form signup-form--step4">
            <StepContainer>
              <Row>
                <Col sm={2} xs={3}>
                  <button
                    data-position="Form - CTA"
                    type="button"
                    onClick={prevStep}
                    className="slick-prev"
                  >
                    Previous
                  </button>
                </Col>
                <Col sm={21} xs={19}>
                  <FormTitle className="signup-form--title" titleColor={secondTitleColor}>
                    How many office staff work at your company?
                    <Tooltip className="signup-form--description-tooltip">
                      How many full-time office employees (eg. manager, dispatchers, CSRs, etc) work
                      at your company?
                    </Tooltip>
                    <span className="signup-form--description-normal">
                      How many full-time office employees (eg. manager, dispatchers, CSRs, etc) work
                      at your company?
                    </span>
                  </FormTitle>
                </Col>
              </Row>
              <Form.Item>
                <RadioGroup
                  id="officeStaffNumber"
                  options={staffCountOptions}
                  formValid
                  handleFocus={onChange}
                  values={values}
                />
              </Form.Item>
            </StepContainer>
          </div>
          <div className="data-layer-form signup-form--step5">
            <StepContainer>
              <Row>
                <Col sm={2} xs={3}>
                  <button
                    data-position="Form - CTA"
                    type="button"
                    onClick={prevStep}
                    className="slick-prev"
                  >
                    Previous
                  </button>
                </Col>
                <Col sm={20} xs={19}>
                  <FormTitle className="signup-form--title" titleColor={secondTitleColor}>
                    What's your company's area of focus?
                  </FormTitle>
                </Col>
              </Row>
              <Form.Item>
                <RadioGroup
                  id="areaOfFocus"
                  options={focusOptions}
                  formValid={formValid}
                  formErrors={formErrors}
                  handleFocus={onFocus}
                  values={values}
                />
              </Form.Item>
              <Row>
                <Col sm={2} xs={3} />
                <Col sm={19} xs={19}>
                  <FormTitle className="signup-form--title" titleColor={secondTitleColor}>
                    What type of work are most of your jobs?
                  </FormTitle>
                </Col>
              </Row>
              <Form.Item>
                <RadioGroup
                  id="typeOfBusiness"
                  options={typeOfWorkOptions}
                  formValid={formValid}
                  formErrors={formErrors}
                  values={values}
                  handleFocus={onFocus}
                />
              </Form.Item>
              <Form.Item data-position="Form - Submit CTA">
                <Button
                  className="signup-form--submit-button-final"
                  type="primary"
                  width="100%"
                  shadow={false}
                  style={{ marginTop: 15 }}
                  onClick={onSubmit}
                >
                  Submit
                </Button>
              </Form.Item>
            </StepContainer>
          </div>
        </Slider>
        {formStep > 0 && (
          <div className="signup-form--progress">
            <Progress percent={getFormPercent()} showInfo={false} strokeColor="#4AB971" />
          </div>
        )}
        <div className={formStep === 0 ? 'signup-form--footer' : 'signup-form--footer-1'}>
          By entering your information above and clicking the{' '}
          {formStep === 0 ? `"Agree and Get Started"` : `"Submit"`} button, you agree to our{' '}
          <a href="/terms-of-use" target="_blank">
            Terms of Use
          </a>{' '}
          and{' '}
          <a href="/privacy-policy" target="_blank">
            Privacy Policy
          </a>
          , and that we may contact you, by SMS, at the phone number and email address you provide
          in this form in accordance with our Terms of Use.
        </div>
      </Form>
    </SignupFormContainer>
  );
};

DemoForm.defaultProps = {
  background: '#ffffff',
  titleColor: 'var(--normal-title-color)',
  title: 'Let’s get started.',
  buttonLabel: 'Agree and Get Started',
  footer: '',
  shadow: true,
  width: '100%',
};

export default DemoForm;
